import { render, staticRenderFns } from "./HabitComboCard.vue?vue&type=template&id=6fba5e3e&scoped=true"
import script from "./HabitComboCard.vue?vue&type=script&lang=js"
export * from "./HabitComboCard.vue?vue&type=script&lang=js"
import style0 from "./HabitComboCard.vue?vue&type=style&index=0&id=6fba5e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba5e3e",
  null
  
)

export default component.exports